import { useMutation } from "react-query";
import { PartnerApi } from "../../api/partner.api";
import { useUnregisteredFTNStore } from "../../store/unregisteredFTN.store";

export const useUnregisteredFTN = () => {
  const setLicenses = useUnregisteredFTNStore((state) => state.setLicenses);

  return useMutation(PartnerApi.unregisteredFTN, {
    onSuccess: (data) => {
      setLicenses(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};
